import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbbrevProvinceState: { input: string; output: string; }
  Answers: { input: any; output: any; }
  Date: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  JSONObject: { input: any; output: any; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  ObjectID: { input: string; output: string; }
  PolicyDescription: { input: "CGL" | "E&O" | "D&O" | "Crime" | "Cyber Liability" | "Legal Expense" | "Medical Malpractice"; output: "CGL" | "E&O" | "D&O" | "Crime" | "Cyber Liability" | "Legal Expense" | "Medical Malpractice"; }
  PositiveFloat: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  ProvinceState: { input: string; output: string; }
  TimeZone: { input: string; output: string; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActiveRenewalData = {
  __typename?: 'ActiveRenewalData';
  stripePlatformAccount: Scalars['String']['output'];
};

export type ActiveRenewalFailureData = {
  __typename?: 'ActiveRenewalFailureData';
  applicationIdStr: Scalars['String']['output'];
  carrierPartner?: Maybe<Scalars['String']['output']>;
  charge_total: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  encryptedData: Scalars['String']['output'];
  invoiceIdStr: Scalars['String']['output'];
  paymentIdStr: Scalars['String']['output'];
  policyFoxdenId: Scalars['String']['output'];
  quoteIdStr: Scalars['String']['output'];
  recordedEmail: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  useCardForRenewals: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  region: Scalars['ProvinceState']['output'];
  street: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  region: Scalars['ProvinceState']['input'];
  street: Scalars['String']['input'];
};

/**
 * Result of a broker-initiated hosted Stripe Checkout Session. The broker
 * frontend redirects to `url`; `sessionId` is the Stripe Checkout Session id.
 */
export type BrokerCheckoutSessionResult = {
  __typename?: 'BrokerCheckoutSessionResult';
  sessionId: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BusinessAddressChange = {
  __typename?: 'BusinessAddressChange';
  newAddress: UnderwritingAddress;
};

export type CalChangedQuoteQuoteInput = {
  objectId: Scalars['ObjectID']['input'];
  results: CalChangedQuoteQuoteResultsInput;
};

export type CalChangedQuoteQuoteResultsInput = {
  calculations: MunichCalculationsInput;
  coverageExpiryDate: Scalars['Date']['input'];
  coverageStartDate: Scalars['Date']['input'];
};

export type CancellationQuoteResponse = {
  __typename?: 'CancellationQuoteResponse';
  quoteExpireDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  results: CancellationQuoteResults;
};

export type CancellationQuoteResults = {
  __typename?: 'CancellationQuoteResults';
  /** Prorated premiums */
  calculations: MunichProratedCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  prevQuoteObjectId: Scalars['ObjectID']['output'];
};

export type CancellationSuccess = {
  __typename?: 'CancellationSuccess';
  result: Scalars['Boolean']['output'];
};

export enum CancellationTrigger {
  Carrier = 'carrier',
  Client = 'client'
}

export type CancelledRenewalData = {
  __typename?: 'CancelledRenewalData';
  cancelledAt: Scalars['String']['output'];
};

export type ChangeCardSessionInput = {
  brokerEmail?: InputMaybe<Scalars['String']['input']>;
  policyNumber: Scalars['String']['input'];
  /**
   * When true, and a past-due installment exists, the change-card Checkout also
   * settles that single arrears installment on the new card. Omitted / null is
   * treated as false, so a plain card swap only saves the card and never charges.
   */
  settleOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangedQuoteResponse = {
  __typename?: 'ChangedQuoteResponse';
  quoteExpireDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  results: ChangedQuoteResults;
};

export type ChangedQuoteResults = {
  __typename?: 'ChangedQuoteResults';
  /** Prorated premiums */
  calculations: MunichProratedCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  /** The quote result for the input answers */
  curQuoteResults: QuoteResults;
  prevQuoteObjectId: Scalars['ObjectID']['output'];
};

export type ChargeSuccess = {
  __typename?: 'ChargeSuccess';
  getInvoiceDeciderResult: GetInvoiceSuccess;
  userPaymentPlanOptionDeciderResult: GetUserPaymentOptionSuccess;
};

export enum ChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CoiAdditionalInsuredInput = {
  address: UnderwritingAddressInput;
  name: Scalars['NonEmptyString']['input'];
};

export type CollectPaymentSessionInput = {
  brokerEmail?: InputMaybe<Scalars['String']['input']>;
  collectionType: PaymentCollectionType;
  policyNumber: Scalars['String']['input'];
};

/**
 * Returned when one or more products in the group are already bound. In the
 * legacy single-product flow, `items` has length 1; multi-prod groups list
 * one entry per bound product so the frontend can surface every
 * already-completed product at once.
 */
export type CompletionData = {
  __typename?: 'CompletionData';
  isCompleted: Scalars['Boolean']['output'];
  items: Array<CompletionDataItem>;
};

export type CompletionDataItem = {
  __typename?: 'CompletionDataItem';
  policyIdStr: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
};

export type ContinuePaymentSessionInput = {
  applicationIdStr: Scalars['String']['input'];
  carrierPartner?: InputMaybe<Scalars['String']['input']>;
  charge_total: Scalars['Float']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  encryptedData?: InputMaybe<Scalars['String']['input']>;
  invoiceIdStr: Scalars['String']['input'];
  paymentIdStr: Scalars['String']['input'];
  policyFoxdenId: Scalars['String']['input'];
  quoteIdStr: Scalars['String']['input'];
  recordedEmail: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  stripePlatformAccount: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  useCardForRenewals: Scalars['Boolean']['input'];
};

export type CoverageLimit = {
  __typename?: 'CoverageLimit';
  coverage: ChildCoverageType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type CoverageUpdateChange = {
  __typename?: 'CoverageUpdateChange';
  coverage: ParentCoverageType;
  limits: Array<CoverageLimit>;
};

export type CreatePaymentInput = {
  invoiceId: Scalars['ObjectID']['input'];
  method: PaymentMethod;
  provider: Provider;
};

export type CreatePaymentSessionInput = {
  /**
   * Either an `Invoice._id` (legacy single-product flow) or an
   * `ApplicationGroup._id` (multi-prod). The controller uses
   * `resolveId` to disambiguate at runtime.
   */
  invoiceIdOrGroupId: Scalars['ObjectID']['input'];
  method: PaymentMethod;
  paymentPlanId: Scalars['NonNegativeFloat']['input'];
  useCardForRenewals: Scalars['Boolean']['input'];
};

export enum CreateRefundableSequenceErrorKind {
  /** No Valid PaymentResult under this Policy */
  NoValidPaymentResult = 'NoValidPaymentResult'
}

/** Currencies that are supported by Foxden. */
export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type DocumentDownloadLink = {
  __typename?: 'DocumentDownloadLink';
  COI: Scalars['String']['output'];
  PaymentReceipt: Scalars['String']['output'];
  T_CDocument: Scalars['String']['output'];
  policyDocument: Scalars['String']['output'];
};

export type DocumentInformation = {
  __typename?: 'DocumentInformation';
  documentDownloadLink: DocumentDownloadLink;
  policyDetails: PolicyDetail;
};

export type EndorsementChange = BusinessAddressChange | CoverageUpdateChange | MailingAddressChange;

export enum FlowKind {
  Cancellation = 'Cancellation',
  /** This means in endorsement flow, we need to charge clients */
  Charge = 'Charge',
  /** This means new business flow. */
  Initial = 'Initial',
  /** This means in endorsement flow, we need to refund clients */
  RefundFullPay = 'RefundFullPay',
  /** This means in endorsement flow, we need to refund clients */
  RefundInstallment = 'RefundInstallment',
  /** This means renewal flow. */
  Renewal = 'Renewal',
  /** This means in endorsement flow, we need to waive */
  Waive = 'Waive'
}

export type FoxdenError = {
  __typename?: 'FoxdenError';
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GetFlowKindSuccess = {
  __typename?: 'GetFlowKindSuccess';
  flowKind: FlowKind;
  isExpired: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  policyFoxdenId: Scalars['String']['output'];
  policyRemoval: PolicyRemoval;
  transactionType: Scalars['String']['output'];
};

/** The error responses for getInvoice. Instead of revealing the data we just return a flag. */
export enum GetInvoiceErrorKind {
  /** This means invoiceId doesn't match our database. Record doesn't exist. */
  NotFound = 'NotFound'
}

export type GetInvoiceResults = FoxdenError | GetInvoiceSuccess;

export type GetInvoiceSuccess = {
  __typename?: 'GetInvoiceSuccess';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  invoiceInfo: InvoiceInfo;
  isExpired: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isRenewalReserved: Scalars['Boolean']['output'];
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['TimeZone']['output'];
  transactionStartDate?: Maybe<Scalars['String']['output']>;
  useCardForRenewals?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPaymentStatusResults = FoxdenError | PaymentStatus;

export type GetPolicyTaxServiceFeeRateResults = FoxdenError | GetPolicyTaxServiceFeeRateSuccess;

export type GetPolicyTaxServiceFeeRateSuccess = {
  __typename?: 'GetPolicyTaxServiceFeeRateSuccess';
  policyFeeRate: Scalars['Float']['output'];
  serviceFeeRate: Scalars['Float']['output'];
  surchargeRate: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
};

export type GetUniqueValueUnderPolicyNumberResults = FoxdenError | UniqueValueUnderPolicyNumber;

export type GetUserPaymentOptionSuccess = {
  __typename?: 'GetUserPaymentOptionSuccess';
  userPaymentPlanOption: Array<UserPaymentPlanOption>;
};

export enum IdType {
  Claim = 'Claim',
  Invoice = 'Invoice',
  Policy = 'Policy',
  Quote = 'Quote',
  Transaction = 'Transaction'
}

export type InactiveRenewalData = {
  __typename?: 'InactiveRenewalData';
  effectiveDate: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

export type InitialSuccess = {
  __typename?: 'InitialSuccess';
  getInvoiceDeciderResult: GetInvoiceSuccess;
  userPaymentPlanOptionDeciderResult: GetUserPaymentOptionSuccess;
};

export enum InstallmentFrequency {
  Annual = 'Annual',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

/** TODO: Update currency type, todo item is to replace currency with real credit card fee in backend */
export type InvoiceClient = {
  __typename?: 'InvoiceClient';
  address: Address;
};

export type InvoiceClientInput = {
  address: AddressInput;
  contactNumber: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  name: NameInput;
  namedInsured: Scalars['NonEmptyString']['input'];
};

export type InvoiceInfo = {
  __typename?: 'InvoiceInfo';
  client?: Maybe<InvoiceClient>;
  currency: Scalars['String']['output'];
  glSurcharge: Scalars['Float']['output'];
  imSurcharge: Scalars['Float']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  policyFee: Scalars['Float']['output'];
  quoteNumber: Scalars['String']['output'];
  surcharge: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  totalPremium: Scalars['Float']['output'];
};

export type InvoiceInfoInput = {
  client: InvoiceClientInput;
  glPolicyFee: Scalars['Float']['input'];
  glPolicyFeeTax: Scalars['Float']['input'];
  glSurcharge: Scalars['Float']['input'];
  imPolicyFee: Scalars['Float']['input'];
  imPolicyFeeTax: Scalars['Float']['input'];
  imSurcharge: Scalars['Float']['input'];
  invoiceDate: Scalars['Date']['input'];
  invoiceNumber: Scalars['String']['input'];
  policyDetails: InvoicePolicyDetailsInput;
  policyFee: Scalars['Float']['input'];
  policyFeeTax: Scalars['Float']['input'];
  quoteNumber: Scalars['String']['input'];
  surcharge: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  totalPremium: Scalars['Float']['input'];
};

export type InvoicePolicyDetailsInput = {
  description: Array<Scalars['PolicyDescription']['input']>;
  effectiveDate: Scalars['Date']['input'];
  notes: Scalars['String']['input'];
};

export type IsExpired = {
  __typename?: 'IsExpired';
  isExpired: Scalars['Boolean']['output'];
};

export type IsPaid = {
  __typename?: 'IsPaid';
  policyNumber: Scalars['String']['output'];
};

export type MailingAddressChange = {
  __typename?: 'MailingAddressChange';
  newAddress: UnderwritingAddress;
};

export type MunichCalculations = {
  __typename?: 'MunichCalculations';
  GL: MunichGlCalculations;
  IM: MunichImCalculations;
  totalPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichCalculationsInput = {
  GL: MunichGlCalculationsInput;
  IM: MunichImCalculationsInput;
  totalPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichGlAggregations = {
  __typename?: 'MunichGLAggregations';
  abuseAndMolestationPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['output'];
  eoPremium: Scalars['NonNegativeFloat']['output'];
  pollutionPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['output'];
  unmannedAircraftPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichGlAggregationsInput = {
  abuseAndMolestationPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['input'];
  eoPremium: Scalars['NonNegativeFloat']['input'];
  pollutionPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['input'];
  unmannedAircraftPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichGlCalculations = {
  __typename?: 'MunichGLCalculations';
  aggregations: MunichGlAggregations;
  labels: MunichGlRateLabels;
};

export type MunichGlCalculationsInput = {
  aggregations: MunichGlAggregationsInput;
  labels: MunichGlRateLabelsInput;
};

export type MunichGlProratedAggregations = {
  __typename?: 'MunichGLProratedAggregations';
  abuseAndMolestationPremium: Scalars['Float']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['Float']['output'];
  eoPremium: Scalars['Float']['output'];
  pollutionPremium: Scalars['Float']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['Float']['output'];
  unmannedAircraftPremium: Scalars['Float']['output'];
};

export type MunichGlProratedCalculations = {
  __typename?: 'MunichGLProratedCalculations';
  aggregations: MunichGlProratedAggregations;
  labels: MunichGlProratedRateLabels;
};

export type MunichGlProratedRateLabels = {
  __typename?: 'MunichGLProratedRateLabels';
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['output'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['output'];
  cglPremPremium: Scalars['NonNegativeFloat']['output'];
  cglProdPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichGlRateLabels = {
  __typename?: 'MunichGLRateLabels';
  abuseMolestationLabels: Scalars['JSONObject']['output'];
  cglAdditionalLimitsLabels: Scalars['JSONObject']['output'];
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['output'];
  cglMeetMinLabels: Scalars['JSONObject']['output'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['output'];
  /** TODO: types can be more specific */
  cglPremLabels: Scalars['JSONObject']['output'];
  /** We can remove these fields or keep these, they are already in the sub labels */
  cglPremPremium: Scalars['NonNegativeFloat']['output'];
  cglProdLabels: Scalars['JSONObject']['output'];
  cglProdPremium: Scalars['NonNegativeFloat']['output'];
  eoLabels: Scalars['JSONObject']['output'];
  pollutionLiabLabels: Scalars['JSONObject']['output'];
  unmannedAircraftLabels: Scalars['JSONObject']['output'];
};

export type MunichGlRateLabelsInput = {
  abuseMolestationLabels: Scalars['JSONObject']['input'];
  cglAdditionalLimitsLabels: Scalars['JSONObject']['input'];
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['input'];
  cglMeetMinLabels: Scalars['JSONObject']['input'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['input'];
  /** TODO: types can be more specific */
  cglPremLabels: Scalars['JSONObject']['input'];
  /** We can remove these fields or keep these, they are already in the sub labels */
  cglPremPremium: Scalars['NonNegativeFloat']['input'];
  cglProdLabels: Scalars['JSONObject']['input'];
  cglProdPremium: Scalars['NonNegativeFloat']['input'];
  eoLabels: Scalars['JSONObject']['input'];
  pollutionLiabLabels: Scalars['JSONObject']['input'];
  unmannedAircraftLabels: Scalars['JSONObject']['input'];
};

export type MunichImAggregations = {
  __typename?: 'MunichIMAggregations';
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichImAggregationsInput = {
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichImCalculations = {
  __typename?: 'MunichIMCalculations';
  aggregations: MunichImAggregations;
  labels: MunichImRateLabels;
};

export type MunichImCalculationsInput = {
  aggregations: MunichImAggregationsInput;
  labels: MunichImRateLabelsInput;
};

export type MunichImProratedAggregations = {
  __typename?: 'MunichIMProratedAggregations';
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['Float']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['Float']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['Float']['output'];
};

export type MunichImProratedCalculations = {
  __typename?: 'MunichIMProratedCalculations';
  aggregations: MunichImProratedAggregations;
  labels: MunichImProratedRateLabels;
};

export type MunichImProratedRateLabels = {
  __typename?: 'MunichIMProratedRateLabels';
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  miniAddPremium: Scalars['NonNegativeFloat']['output'];
  miniPremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichImRateLabels = {
  __typename?: 'MunichIMRateLabels';
  contractorsLockAndKeyLabels: Scalars['JSONObject']['output'];
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  hardwareAndSoftwareLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  lockAndKeyLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  miniAddPremium: Scalars['NonNegativeFloat']['output'];
  miniPremium: Scalars['NonNegativeFloat']['output'];
  photographyAndVideographyLebels: Scalars['JSONObject']['output'];
  physicalLossLabels: Scalars['JSONObject']['output'];
  unscheduledBPPLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['output'];
  unscheduledContractorsEquipmentLebels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['output'];
  unscheduledHardwareAndSoftwareLabels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  unscheduledSmallToolsLebels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['output'];
  valualePapersLebels: Scalars['JSONObject']['output'];
};

export type MunichImRateLabelsInput = {
  contractorsLockAndKeyLabels: Scalars['JSONObject']['input'];
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['input'];
  hardwareAndSoftwareLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['input'];
  lockAndKeyLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['input'];
  miniAddPremium: Scalars['NonNegativeFloat']['input'];
  miniPremium: Scalars['NonNegativeFloat']['input'];
  photographyAndVideographyLebels: Scalars['JSONObject']['input'];
  physicalLossLabels: Scalars['JSONObject']['input'];
  unscheduledBPPLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['input'];
  unscheduledContractorsEquipmentLebels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['input'];
  unscheduledHardwareAndSoftwareLabels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['input'];
  unscheduledSmallToolsLebels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['input'];
  valualePapersLebels: Scalars['JSONObject']['input'];
};

export type MunichProratedCalculations = {
  __typename?: 'MunichProratedCalculations';
  GL: MunichGlProratedCalculations;
  IM: MunichImProratedCalculations;
  newCharge: Scalars['Float']['output'];
  prorateFactor: Scalars['NonNegativeFloat']['output'];
  totalPremium: Scalars['NonNegativeFloat']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelationRefund: Scalars['Boolean']['output'];
  /**
   * Broker/admin action: create a hosted Stripe Checkout Session to change the
   * card on file. Only captures the new card by default; charges the outstanding
   * (past-due) installment on the new card ONLY when `settleOutstanding` is true
   * and such an installment exists.
   */
  changeCardSession: BrokerCheckoutSessionResult;
  /**
   * Broker/admin action: create a hosted Stripe Checkout Session to collect
   * either the due installment or the full outstanding balance against a
   * policy's existing Stripe customer. On successful full-outstanding
   * collection the policy's future installments are cancelled by the webhook.
   */
  collectPaymentSession: BrokerCheckoutSessionResult;
  completeRefund: Scalars['Boolean']['output'];
  createPaymentSession: PaymentSessionResult;
  generateSigningURL: Scalars['URL']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  /** This creates an invoice object in the database and returns a corresponding payment URL. */
  proceedToPayment: Scalars['String']['output'];
  saveInvoice: Scalars['URL']['output'];
  sendCOI: Scalars['Boolean']['output'];
  sendInvoiceLinkEmail: Scalars['Boolean']['output'];
  sendTnCESignature: Scalars['Boolean']['output'];
  storeInvoiceInfo: Scalars['ObjectID']['output'];
};


export type MutationCancelationRefundArgs = {
  invoiceId: Scalars['ObjectID']['input'];
};


export type MutationChangeCardSessionArgs = {
  input: ChangeCardSessionInput;
};


export type MutationCollectPaymentSessionArgs = {
  input: CollectPaymentSessionInput;
};


export type MutationCompleteRefundArgs = {
  creditMemoObjectId: Scalars['ObjectID']['input'];
};


export type MutationCreatePaymentSessionArgs = {
  checkoutInfo?: InputMaybe<ContinuePaymentSessionInput>;
  isContinuing: Scalars['Boolean']['input'];
  paymentInfo?: InputMaybe<CreatePaymentSessionInput>;
};


export type MutationGenerateSigningUrlArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type MutationProceedToPaymentArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type MutationSaveInvoiceArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type MutationSendCoiArgs = {
  additionalInsured: CoiAdditionalInsuredInput;
  country: Scalars['String']['input'];
  policyFoxdenId: Scalars['String']['input'];
};


export type MutationSendInvoiceLinkEmailArgs = {
  encryptedString: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};


export type MutationSendTnCeSignatureArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationStoreInvoiceInfoArgs = {
  invoice: InvoiceInfoInput;
};

export type Name = {
  __typename?: 'Name';
  first: Scalars['String']['output'];
  last: Scalars['String']['output'];
  middle: Scalars['String']['output'];
};

export type NameInput = {
  first: Scalars['String']['input'];
  last: Scalars['String']['input'];
  middle: Scalars['String']['input'];
};

export enum ParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Inland Marine */
  Im = 'IM'
}

/**
 * Some products in the group are bound and the rest still owe payment; the
 * client is redirected to the open retry Checkout Session. Returned under every LOB key.
 */
export type PartiallyPaid = {
  __typename?: 'PartiallyPaid';
  redirectUrl: Scalars['String']['output'];
};

/**
 * What a broker collect-payment session should charge. Exactly one of the two:
 * the single installment currently due, or the entire outstanding balance.
 */
export enum PaymentCollectionType {
  DueInstallment = 'DUE_INSTALLMENT',
  FullOutstanding = 'FULL_OUTSTANDING'
}

export enum PaymentMethod {
  CreditCard = 'CreditCard'
}

export type PaymentRouteDeciderResults = CancellationSuccess | CancelledRenewalData | ChargeSuccess | FoxdenError | InitialSuccess | IsExpired | IsPaid | PartiallyPaid | RefundFullPaySuccess | RefundInstallmentSuccess | WaiveSuccess;

/**
 * Per-LOB payment-route decisions for an application group. Each field is the
 * decision for that line of business, or null when the group does not carry it.
 */
export type PaymentRouteDeciderResultsByLob = {
  __typename?: 'PaymentRouteDeciderResultsByLob';
  EO?: Maybe<PaymentRouteDeciderResults>;
  GL?: Maybe<PaymentRouteDeciderResults>;
};

export type PaymentSessionResult = ActiveRenewalData | ActiveRenewalFailureData | CancelledRenewalData | CompletionData | InactiveRenewalData | StripeData;

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  invoiceInfo: PaymentStatusInvoiceInfo;
  isPaid: Scalars['Boolean']['output'];
  isRenewalReserved: Scalars['Boolean']['output'];
  isSettled: Scalars['Boolean']['output'];
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
  /**
   * Live URL of a Stripe Checkout Session the BACKEND opened for this
   * ApplicationGroup after a product's charge failed, for the frontend to
   * redirect the customer to. Present only while the group still owes money
   * and such a session is open; null otherwise, including for the sessions
   * createPaymentSession opens, which the frontend already holds the URL for.
   *
   * GROUP-scoped: one retry session covers the whole group, so every product
   * in the response carries the same value.
   */
  stripeCheckoutSessionRedirectUrl?: Maybe<Scalars['String']['output']>;
  transactionStartDate?: Maybe<Scalars['String']['output']>;
};

export type PaymentStatusInvoiceInfo = {
  __typename?: 'PaymentStatusInvoiceInfo';
  client?: Maybe<InvoiceClient>;
};

export enum PolicyCancelReason {
  /** Business Closed */
  BusinessClosed = 'BusinessClosed',
  /** Business Sold */
  BusinessSold = 'BusinessSold',
  /** Found Better Pricing Elsewhere */
  FoundBetterPricingElsewhere = 'FoundBetterPricingElsewhere',
  /** Insurance Is No Longer Required */
  InsuranceIsNoLongerRequired = 'InsuranceIsNoLongerRequired',
  /** Other */
  Other = 'Other'
}

export type PolicyDetail = {
  __typename?: 'PolicyDetail';
  country: Scalars['String']['output'];
  insuredLocation: UnderwritingAddress;
  mailingAddress: UnderwritingAddress;
  namedInsured: Scalars['String']['output'];
  operations: Array<Scalars['String']['output']>;
  policyEndDate: Scalars['Date']['output'];
  policyStartDate: Scalars['Date']['output'];
  timeZone: Scalars['TimeZone']['output'];
};

export type PolicyRemoval = {
  __typename?: 'PolicyRemoval';
  premium?: Maybe<Premium>;
  removal?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  waivedPremium?: Maybe<WaivedPremium>;
};

export type Premium = {
  __typename?: 'Premium';
  glEarnedPremium: Scalars['Float']['output'];
  glRefundPremium: Scalars['Float']['output'];
  imEarnedPremium: Scalars['Float']['output'];
  imRefundPremium: Scalars['Float']['output'];
};

export enum Provider {
  Stripe = 'Stripe'
}

export type Query = {
  __typename?: 'Query';
  generateRenewalTnC: Scalars['URL']['output'];
  generateTnCDocument?: Maybe<Scalars['String']['output']>;
  /**
   * Resolve a Quote id (legacy T&C links) or an ApplicationGroup id to the
   * owning ApplicationGroup id. Lets the payment frontend canonicalize
   * /terms/<id> links to /terms/<applicationGroupId>.
   */
  getApplicationGroupId: Scalars['ObjectID']['output'];
  getApplicationJurisdiction: GetApplicationJurisdictionResponse;
  getAuth0UserPolicies: Array<Scalars['String']['output']>;
  getCustomerAndBrokerInfo: GetCustomerAndBrokerInfoResponse;
  /**
   * Accepts an invoice id or an ApplicationGroup id so every sibling product in
   * the group is loaded. Returns a map keyed by lobType (e.g. "GL", "EO"); each
   * value is a { isDocuSignEnvelopeSigned } status object for that line of
   * business. Modelled as a JSONObject scalar because GraphQL has no native
   * arbitrary-key map type and the resolver returns the per-lob map directly
   * from the controller.
   */
  getDocuSignEnvelopeSignedStatusByInvoiceOrGroupId: Scalars['JSONObject']['output'];
  getDocumentInformation: DocumentInformation;
  getEmailAddress: Scalars['String']['output'];
  /** This API only returns the invoice only if there's an associated complete payment. */
  getInvoice: GetInvoiceResults;
  getPaymentStatus: Array<GetPaymentStatusResults>;
  getPolicyTaxServiceFeeRate: GetPolicyTaxServiceFeeRateResults;
  getUniqueValueUnderPolicyNumber: GetUniqueValueUnderPolicyNumberResults;
  getUserPaymentPlanOption: Array<UserPaymentPlanOption>;
  /**
   * Accepts an ApplicationGroup id so every sibling product in the group is
   * loaded. Returns a map keyed by lobType (e.g. "GL", "EO"); each value is an
   * array of UserPaymentPlanOptionByQuoteID for that line of business. Modelled
   * as a JSONObject scalar because GraphQL has no native arbitrary-key map type
   * and the resolver returns the per-lob map directly from the controller.
   */
  getUserPaymentPlanOptionsByGroupId: Scalars['JSONObject']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  /**
   * NCP-4701 — returns the presigned download link for a single customer
   * document (documentType is one of: policyDocument, COI, PaymentReceipt,
   * T_CDocument) and audits the download.
   */
  openCustomerDocument?: Maybe<Scalars['String']['output']>;
  paymentRouteDecider: PaymentRouteDeciderResultsByLob;
};


export type QueryGenerateRenewalTnCArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGenerateTnCDocumentArgs = {
  answers: Scalars['JSONObject']['input'];
  carrierPartner: Scalars['String']['input'];
  country: Scalars['String']['input'];
  jsonFileName: Scalars['String']['input'];
  rating: Scalars['JSONObject']['input'];
};


export type QueryGetApplicationGroupIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetApplicationJurisdictionArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetCustomerAndBrokerInfoArgs = {
  invoiceIdOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdArgs = {
  invoiceOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetDocumentInformationArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryGetEmailAddressArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['ObjectID']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryGetPaymentStatusArgs = {
  invoiceId: Scalars['ObjectID']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryGetPolicyTaxServiceFeeRateArgs = {
  country: Scalars['String']['input'];
  provinceOrState: Scalars['String']['input'];
};


export type QueryGetUniqueValueUnderPolicyNumberArgs = {
  policyNumber: Scalars['String']['input'];
};


export type QueryGetUserPaymentPlanOptionArgs = {
  InvoiceId: Scalars['ObjectID']['input'];
};


export type QueryGetUserPaymentPlanOptionsByGroupIdArgs = {
  groupId: Scalars['ObjectID']['input'];
};


export type QueryOpenCustomerDocumentArgs = {
  documentType: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type QueryPaymentRouteDeciderArgs = {
  invoiceId: Scalars['ObjectID']['input'];
};

export type QuoteResponse = {
  __typename?: 'QuoteResponse';
  premium: Scalars['Float']['output'];
  quoteId: Scalars['ObjectID']['output'];
  quoteNumber: Scalars['String']['output'];
};

/** This isn't used in the Graphql API; used for generating Typescript type. */
export type QuoteResults = {
  __typename?: 'QuoteResults';
  calculations: MunichCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  ratingInput: Scalars['JSONObject']['output'];
};

export type QuoteResultsInput = {
  calculations: MunichCalculationsInput;
  coverageExpiryDate: Scalars['Date']['input'];
  coverageStartDate: Scalars['Date']['input'];
  ratingInput: Scalars['JSONObject']['input'];
};

export type RefundFullPaySuccess = {
  __typename?: 'RefundFullPaySuccess';
  refundedSequence: Array<RefundableSequenceItem>;
};

export type RefundInstallmentSuccess = {
  __typename?: 'RefundInstallmentSuccess';
  result: Scalars['Boolean']['output'];
};

export type RefundableSequenceItem = {
  __typename?: 'RefundableSequenceItem';
  invoiceId: Scalars['ObjectID']['output'];
  paymentIntentId: Scalars['String']['output'];
  refundableAmount: Scalars['NonNegativeFloat']['output'];
  timestamp: Scalars['Date']['output'];
};

export type StripeData = {
  __typename?: 'StripeData';
  session_id: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
};

export enum UsCancellationMethod {
  /** Flat */
  Flat = 'Flat',
  /** Pro Rata */
  ProRata = 'ProRata',
  /** Short Rate */
  ShortRate = 'ShortRate'
}

export enum UsPolicyCancelReason {
  /** Not Taken */
  NotTaken = 'NotTaken',
  /** Other */
  Other = 'Other',
  /** Requested by Insured */
  RequestByInsured = 'RequestByInsured',
  /** Rewritten */
  Rewritten = 'Rewritten'
}

export enum UsRequestDistribution {
  Company = 'Company',
  FinanceCompany = 'FinanceCompany',
  Insured = 'Insured',
  LenderLossPayable = 'LenderLossPayable',
  Lienholder = 'Lienholder',
  LossPayee = 'LossPayee',
  Mortgagee = 'Mortgagee'
}

export type UnderwritingAddress = {
  __typename?: 'UnderwritingAddress';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  province: Scalars['AbbrevProvinceState']['output'];
  street: Scalars['String']['output'];
};

export type UnderwritingAddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  province: Scalars['AbbrevProvinceState']['input'];
  street: Scalars['String']['input'];
};

export type UniqueValueUnderPolicyNumber = {
  __typename?: 'UniqueValueUnderPolicyNumber';
  subscriptionScheduleId: Scalars['String']['output'];
};

/** Needs to send this URL to customer for signing the Terms & Conditions before the endorsement can take effect. */
export type UpdatePolicyProceedToTerms = {
  __typename?: 'UpdatePolicyProceedToTerms';
  /** The ObjectID for the temporary policy object created by this operation. */
  insertedObjectId: Scalars['ObjectID']['output'];
  /** Does this endorsement possibly require payment or refund */
  isInvolvePayment: Scalars['Boolean']['output'];
  /** The new charge */
  newCharge?: Maybe<Scalars['Float']['output']>;
  /** URL to Docusign page. */
  url: Scalars['URL']['output'];
};

export type UserPaymentPlanOption = {
  __typename?: 'UserPaymentPlanOption';
  downPayment: Scalars['NonNegativeFloat']['output'];
  installmentAmount: Scalars['NonNegativeFloat']['output'];
  installmentFrequency: Scalars['String']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  numberOfInstallments: Scalars['NonNegativeFloat']['output'];
  paymentPlan: Scalars['String']['output'];
  paymentPlanId: Scalars['NonNegativeFloat']['output'];
  paymentSchedule: Array<Maybe<Scalars['Date']['output']>>;
  policyInceptionDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  totalPayable: Scalars['NonNegativeFloat']['output'];
  totalPolicyFees: Scalars['NonNegativeFloat']['output'];
  totalPremiumAmount: Scalars['NonNegativeFloat']['output'];
  totalServiceFees: Scalars['NonNegativeFloat']['output'];
  totalSurcharge: Scalars['NonNegativeFloat']['output'];
  totalTaxes: Scalars['NonNegativeFloat']['output'];
};

export type UserPaymentPlanOptionByQuoteId = {
  __typename?: 'UserPaymentPlanOptionByQuoteID';
  downPayment: Scalars['NonNegativeFloat']['output'];
  installmentAmount: Scalars['NonNegativeFloat']['output'];
  installmentFrequency: Scalars['String']['output'];
  numberOfInstallments: Scalars['NonNegativeFloat']['output'];
  paymentPlan: Scalars['String']['output'];
  paymentPlanId: Scalars['NonNegativeFloat']['output'];
  surcharge: Scalars['Float']['output'];
  totalPayable: Scalars['NonNegativeFloat']['output'];
  totalPolicyFees: Scalars['NonNegativeFloat']['output'];
  totalPremiumAmount: Scalars['NonNegativeFloat']['output'];
  totalServiceFees: Scalars['NonNegativeFloat']['output'];
  totalTaxes: Scalars['NonNegativeFloat']['output'];
};

export type ValidateEndorsementResult = {
  __typename?: 'ValidateEndorsementResult';
  changes: Array<EndorsementChange>;
  effectiveDate: Scalars['Date']['output'];
  isInvolvePayment: Scalars['Boolean']['output'];
};

export type WaiveSuccess = {
  __typename?: 'WaiveSuccess';
  result: Scalars['Boolean']['output'];
};

export type WaivedPremium = {
  __typename?: 'WaivedPremium';
  Canada?: Maybe<Scalars['Float']['output']>;
  GLForUs?: Maybe<Scalars['Float']['output']>;
  IMForUs?: Maybe<Scalars['Float']['output']>;
};

export type GetApplicationJurisdictionResponse = {
  __typename?: 'getApplicationJurisdictionResponse';
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GetCustomerAndBrokerInfoResponse = {
  __typename?: 'getCustomerAndBrokerInfoResponse';
  brokerEmail?: Maybe<Scalars['String']['output']>;
  brokerName?: Maybe<Scalars['String']['output']>;
  customerEmail: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /**
   * Owning ApplicationGroup id. The payment-frontend sends this to
   * sendTnCESignature (group-scoped e-sign) and builds the canonical
   * /terms/<applicationGroupId> link. The resolver already computes it.
   */
  groupId: Scalars['ObjectID']['output'];
  quoteId?: Maybe<Scalars['ObjectID']['output']>;
};

export type GetApplicationGroupIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetApplicationGroupIdQuery = { __typename?: 'Query', getApplicationGroupId: string };

export type GetEmailAddressQueryVariables = Exact<{
  quoteOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GetEmailAddressQuery = { __typename?: 'Query', getEmailAddress: string };

export type CreatePaymentSessionMutationVariables = Exact<{
  isContinuing: Scalars['Boolean']['input'];
  paymentInfo?: InputMaybe<CreatePaymentSessionInput>;
  checkoutInfo?: InputMaybe<ContinuePaymentSessionInput>;
}>;


export type CreatePaymentSessionMutation = { __typename?: 'Mutation', createPaymentSession: { __typename: 'ActiveRenewalData', stripePlatformAccount: string } | { __typename: 'ActiveRenewalFailureData', currency: string, charge_total: number, paymentIdStr: string, invoiceIdStr: string, quoteIdStr: string, applicationIdStr: string, useCardForRenewals: boolean, recordedEmail: string, stripePlatformAccount: string, country: string, carrierPartner?: string | null, timeZone: string, signature: string, policyFoxdenId: string, encryptedData: string } | { __typename: 'CancelledRenewalData', cancelledAt: string } | { __typename: 'CompletionData', isCompleted: boolean, items: Array<{ __typename?: 'CompletionDataItem', policyIdStr: string, policyNumber: string }> } | { __typename: 'InactiveRenewalData', paymentId: string, invoiceId: string, effectiveDate: string } | { __typename: 'StripeData', session_id: string, stripePlatformAccount: string } };

export type GetApplicationJurisdictionQueryVariables = Exact<{
  quoteOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GetApplicationJurisdictionQuery = { __typename?: 'Query', getApplicationJurisdiction: { __typename?: 'getApplicationJurisdictionResponse', country: string, state: string } };

export type GetCustomerAndBrokerInfoQueryVariables = Exact<{
  invoiceIdOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GetCustomerAndBrokerInfoQuery = { __typename?: 'Query', getCustomerAndBrokerInfo: { __typename?: 'getCustomerAndBrokerInfoResponse', groupId: string, quoteId?: string | null, customerName: string, customerEmail: string, brokerName?: string | null, brokerEmail?: string | null } };

export type GetDocumentInformationQueryVariables = Exact<{
  policyId: Scalars['String']['input'];
}>;


export type GetDocumentInformationQuery = { __typename?: 'Query', getDocumentInformation: { __typename?: 'DocumentInformation', documentDownloadLink: { __typename?: 'DocumentDownloadLink', COI: string, PaymentReceipt: string, T_CDocument: string, policyDocument: string }, policyDetails: { __typename?: 'PolicyDetail', namedInsured: string, operations: Array<string>, policyEndDate: string, policyStartDate: string, timeZone: string, country: string, insuredLocation: { __typename?: 'UnderwritingAddress', city: string, postalCode: string, province: string, street: string }, mailingAddress: { __typename?: 'UnderwritingAddress', city: string, postalCode: string, province: string, street: string } } } };

export type GetAuth0UserPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuth0UserPoliciesQuery = { __typename?: 'Query', getAuth0UserPolicies: Array<string> };

export type GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables = Exact<{
  invoiceOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery = { __typename?: 'Query', getDocuSignEnvelopeSignedStatusByInvoiceOrGroupId: any };

export type GetPaymentPlanOptionQueryVariables = Exact<{
  InvoiceId: Scalars['ObjectID']['input'];
}>;


export type GetPaymentPlanOptionQuery = { __typename?: 'Query', getUserPaymentPlanOption: Array<{ __typename?: 'UserPaymentPlanOption', paymentPlanId: number, paymentPlan: string, invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremiumAmount: number, totalSurcharge: number, totalTaxes: number, totalPolicyFees: number, totalServiceFees: number, totalPayable: number, policyInceptionDate: string, downPayment: number, numberOfInstallments: number, installmentFrequency: string, installmentAmount: number, paymentSchedule: Array<string | null> }> };

export type OpenCustomerDocumentQueryVariables = Exact<{
  policyId: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
}>;


export type OpenCustomerDocumentQuery = { __typename?: 'Query', openCustomerDocument?: string | null };

export type SendInvoiceLinkEmailMutationVariables = Exact<{
  encryptedString: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type SendInvoiceLinkEmailMutation = { __typename?: 'Mutation', sendInvoiceLinkEmail: boolean };

export type SendTnCeSignatureMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
  subject: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendTnCeSignatureMutation = { __typename?: 'Mutation', sendTnCESignature: boolean };

export type StoreInvoiceInfoMutationVariables = Exact<{
  invoice: InvoiceInfoInput;
}>;


export type StoreInvoiceInfoMutation = { __typename?: 'Mutation', storeInvoiceInfo: string };

export type SendCoiMutationVariables = Exact<{
  additionalInsured: CoiAdditionalInsuredInput;
  policyFoxdenId: Scalars['String']['input'];
  country: Scalars['String']['input'];
}>;


export type SendCoiMutation = { __typename?: 'Mutation', sendCOI: boolean };

export type GetPaymentStatusQueryVariables = Exact<{
  invoiceId: Scalars['ObjectID']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type GetPaymentStatusQuery = { __typename?: 'Query', getPaymentStatus: Array<{ __typename: 'FoxdenError', fileName: string, message: string } | { __typename: 'PaymentStatus', isPaid: boolean, isSettled: boolean, policyFoxdenId?: string | null, isRenewalReserved: boolean, effectiveDate?: string | null, transactionStartDate?: string | null, stripeCheckoutSessionRedirectUrl?: string | null, invoiceInfo: { __typename?: 'PaymentStatusInvoiceInfo', client?: { __typename?: 'InvoiceClient', address: { __typename?: 'Address', city: string, postalCode: string, street: string, region: string } } | null } }> };

export type InitiatePaymentGetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ObjectID']['input'];
}>;


export type InitiatePaymentGetInvoiceQuery = { __typename?: 'Query', getInvoice: { __typename: 'FoxdenError', fileName: string, message: string } | { __typename: 'GetInvoiceSuccess', isExpired: boolean, isPaid: boolean, policyFoxdenId?: string | null, invoiceInfo: { __typename?: 'InvoiceInfo', invoiceDate: string, invoiceNumber: string, quoteNumber: string, tax: number, totalPremium: number, policyFee: number, currency: string, client?: { __typename?: 'InvoiceClient', address: { __typename?: 'Address', city: string, postalCode: string, street: string, region: string } } | null } } };

export type GetPaymentRouteDeciderQueryVariables = Exact<{
  invoiceId: Scalars['ObjectID']['input'];
}>;


export type GetPaymentRouteDeciderQuery = { __typename?: 'Query', paymentRouteDecider: { __typename: 'PaymentRouteDeciderResultsByLob', GL?: { __typename: 'CancellationSuccess' } | { __typename: 'CancelledRenewalData' } | { __typename: 'ChargeSuccess', getInvoiceDeciderResult: { __typename?: 'GetInvoiceSuccess', isPaid: boolean, isExpired: boolean, policyFoxdenId?: string | null, timeZone: string, invoiceInfo: { __typename?: 'InvoiceInfo', invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremium: number, tax: number, policyFee: number, currency: string } }, userPaymentPlanOptionDeciderResult: { __typename?: 'GetUserPaymentOptionSuccess', userPaymentPlanOption: Array<{ __typename?: 'UserPaymentPlanOption', paymentPlanId: number, paymentPlan: string, invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremiumAmount: number, totalSurcharge: number, totalTaxes: number, totalPolicyFees: number, totalServiceFees: number, totalPayable: number, policyInceptionDate: string, downPayment: number, numberOfInstallments: number, installmentFrequency: string, installmentAmount: number, paymentSchedule: Array<string | null> }> } } | { __typename: 'FoxdenError', fileName: string, message: string } | { __typename: 'InitialSuccess', getInvoiceDeciderResult: { __typename?: 'GetInvoiceSuccess', isPaid: boolean, isExpired: boolean, policyFoxdenId?: string | null, timeZone: string, useCardForRenewals?: boolean | null, invoiceInfo: { __typename?: 'InvoiceInfo', invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremium: number, tax: number, policyFee: number, currency: string, client?: { __typename?: 'InvoiceClient', address: { __typename?: 'Address', city: string, postalCode: string, street: string, region: string } } | null } }, userPaymentPlanOptionDeciderResult: { __typename?: 'GetUserPaymentOptionSuccess', userPaymentPlanOption: Array<{ __typename?: 'UserPaymentPlanOption', paymentPlanId: number, paymentPlan: string, invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremiumAmount: number, totalSurcharge: number, totalTaxes: number, totalPolicyFees: number, totalServiceFees: number, totalPayable: number, policyInceptionDate: string, downPayment: number, numberOfInstallments: number, installmentFrequency: string, installmentAmount: number, paymentSchedule: Array<string | null>, isDefault?: boolean | null }> } } | { __typename: 'IsExpired', isExpired: boolean } | { __typename: 'IsPaid', policyNumber: string } | { __typename: 'PartiallyPaid', redirectUrl: string } | { __typename: 'RefundFullPaySuccess', refundedSequence: Array<{ __typename?: 'RefundableSequenceItem', timestamp: string, paymentIntentId: string, invoiceId: string, refundableAmount: number }> } | { __typename: 'RefundInstallmentSuccess' } | { __typename: 'WaiveSuccess' } | null, EO?: { __typename: 'CancellationSuccess' } | { __typename: 'CancelledRenewalData' } | { __typename: 'ChargeSuccess', getInvoiceDeciderResult: { __typename?: 'GetInvoiceSuccess', isPaid: boolean, isExpired: boolean, policyFoxdenId?: string | null, timeZone: string, invoiceInfo: { __typename?: 'InvoiceInfo', invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremium: number, tax: number, policyFee: number, currency: string } }, userPaymentPlanOptionDeciderResult: { __typename?: 'GetUserPaymentOptionSuccess', userPaymentPlanOption: Array<{ __typename?: 'UserPaymentPlanOption', paymentPlanId: number, paymentPlan: string, invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremiumAmount: number, totalSurcharge: number, totalTaxes: number, totalPolicyFees: number, totalServiceFees: number, totalPayable: number, policyInceptionDate: string, downPayment: number, numberOfInstallments: number, installmentFrequency: string, installmentAmount: number, paymentSchedule: Array<string | null> }> } } | { __typename: 'FoxdenError', fileName: string, message: string } | { __typename: 'InitialSuccess', getInvoiceDeciderResult: { __typename?: 'GetInvoiceSuccess', isPaid: boolean, isExpired: boolean, policyFoxdenId?: string | null, timeZone: string, useCardForRenewals?: boolean | null, invoiceInfo: { __typename?: 'InvoiceInfo', invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremium: number, tax: number, policyFee: number, currency: string, client?: { __typename?: 'InvoiceClient', address: { __typename?: 'Address', city: string, postalCode: string, street: string, region: string } } | null } }, userPaymentPlanOptionDeciderResult: { __typename?: 'GetUserPaymentOptionSuccess', userPaymentPlanOption: Array<{ __typename?: 'UserPaymentPlanOption', paymentPlanId: number, paymentPlan: string, invoiceNumber: string, invoiceDate: string, quoteNumber: string, totalPremiumAmount: number, totalSurcharge: number, totalTaxes: number, totalPolicyFees: number, totalServiceFees: number, totalPayable: number, policyInceptionDate: string, downPayment: number, numberOfInstallments: number, installmentFrequency: string, installmentAmount: number, paymentSchedule: Array<string | null>, isDefault?: boolean | null }> } } | { __typename: 'IsExpired', isExpired: boolean } | { __typename: 'IsPaid', policyNumber: string } | { __typename: 'PartiallyPaid', redirectUrl: string } | { __typename: 'RefundFullPaySuccess', refundedSequence: Array<{ __typename?: 'RefundableSequenceItem', timestamp: string, paymentIntentId: string, invoiceId: string, refundableAmount: number }> } | { __typename: 'RefundInstallmentSuccess' } | { __typename: 'WaiveSuccess' } | null } };

export type GenerateSigningUrlMutationVariables = Exact<{
  quoteOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GenerateSigningUrlMutation = { __typename?: 'Mutation', generateSigningURL: any };


export const GetApplicationGroupIdDocument = gql`
    query getApplicationGroupId($id: ObjectID!) {
  getApplicationGroupId(id: $id)
}
    `;

/**
 * __useGetApplicationGroupIdQuery__
 *
 * To run a query within a React component, call `useGetApplicationGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationGroupIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationGroupIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApplicationGroupIdQuery, GetApplicationGroupIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplicationGroupIdQuery, GetApplicationGroupIdQueryVariables>(GetApplicationGroupIdDocument, options);
      }
export function useGetApplicationGroupIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplicationGroupIdQuery, GetApplicationGroupIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplicationGroupIdQuery, GetApplicationGroupIdQueryVariables>(GetApplicationGroupIdDocument, options);
        }
export type GetApplicationGroupIdQueryHookResult = ReturnType<typeof useGetApplicationGroupIdQuery>;
export type GetApplicationGroupIdLazyQueryHookResult = ReturnType<typeof useGetApplicationGroupIdLazyQuery>;
export type GetApplicationGroupIdQueryResult = ApolloReactCommon.QueryResult<GetApplicationGroupIdQuery, GetApplicationGroupIdQueryVariables>;
export const GetEmailAddressDocument = gql`
    query getEmailAddress($quoteOrGroupId: ObjectID!) {
  getEmailAddress(quoteOrGroupId: $quoteOrGroupId)
}
    `;

/**
 * __useGetEmailAddressQuery__
 *
 * To run a query within a React component, call `useGetEmailAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAddressQuery({
 *   variables: {
 *      quoteOrGroupId: // value for 'quoteOrGroupId'
 *   },
 * });
 */
export function useGetEmailAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmailAddressQuery, GetEmailAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmailAddressQuery, GetEmailAddressQueryVariables>(GetEmailAddressDocument, options);
      }
export function useGetEmailAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailAddressQuery, GetEmailAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmailAddressQuery, GetEmailAddressQueryVariables>(GetEmailAddressDocument, options);
        }
export type GetEmailAddressQueryHookResult = ReturnType<typeof useGetEmailAddressQuery>;
export type GetEmailAddressLazyQueryHookResult = ReturnType<typeof useGetEmailAddressLazyQuery>;
export type GetEmailAddressQueryResult = ApolloReactCommon.QueryResult<GetEmailAddressQuery, GetEmailAddressQueryVariables>;
export const CreatePaymentSessionDocument = gql`
    mutation createPaymentSession($isContinuing: Boolean!, $paymentInfo: CreatePaymentSessionInput, $checkoutInfo: ContinuePaymentSessionInput) {
  createPaymentSession(
    isContinuing: $isContinuing
    paymentInfo: $paymentInfo
    checkoutInfo: $checkoutInfo
  ) {
    ... on ActiveRenewalData {
      stripePlatformAccount
      __typename
    }
    ... on ActiveRenewalFailureData {
      currency
      charge_total
      paymentIdStr
      invoiceIdStr
      quoteIdStr
      applicationIdStr
      useCardForRenewals
      recordedEmail
      stripePlatformAccount
      country
      carrierPartner
      timeZone
      signature
      policyFoxdenId
      encryptedData
      __typename
    }
    ... on InactiveRenewalData {
      paymentId
      invoiceId
      effectiveDate
      __typename
    }
    ... on StripeData {
      session_id
      stripePlatformAccount
      __typename
    }
    ... on CompletionData {
      isCompleted
      items {
        policyIdStr
        policyNumber
      }
      __typename
    }
    ... on CancelledRenewalData {
      cancelledAt
      __typename
    }
    __typename
  }
}
    `;
export type CreatePaymentSessionMutationFn = ApolloReactCommon.MutationFunction<CreatePaymentSessionMutation, CreatePaymentSessionMutationVariables>;

/**
 * __useCreatePaymentSessionMutation__
 *
 * To run a mutation, you first call `useCreatePaymentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentSessionMutation, { data, loading, error }] = useCreatePaymentSessionMutation({
 *   variables: {
 *      isContinuing: // value for 'isContinuing'
 *      paymentInfo: // value for 'paymentInfo'
 *      checkoutInfo: // value for 'checkoutInfo'
 *   },
 * });
 */
export function useCreatePaymentSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentSessionMutation, CreatePaymentSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentSessionMutation, CreatePaymentSessionMutationVariables>(CreatePaymentSessionDocument, options);
      }
export type CreatePaymentSessionMutationHookResult = ReturnType<typeof useCreatePaymentSessionMutation>;
export type CreatePaymentSessionMutationResult = ApolloReactCommon.MutationResult<CreatePaymentSessionMutation>;
export type CreatePaymentSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePaymentSessionMutation, CreatePaymentSessionMutationVariables>;
export const GetApplicationJurisdictionDocument = gql`
    query getApplicationJurisdiction($quoteOrGroupId: ObjectID!) {
  getApplicationJurisdiction(quoteOrGroupId: $quoteOrGroupId) {
    country
    state
  }
}
    `;

/**
 * __useGetApplicationJurisdictionQuery__
 *
 * To run a query within a React component, call `useGetApplicationJurisdictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationJurisdictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationJurisdictionQuery({
 *   variables: {
 *      quoteOrGroupId: // value for 'quoteOrGroupId'
 *   },
 * });
 */
export function useGetApplicationJurisdictionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApplicationJurisdictionQuery, GetApplicationJurisdictionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplicationJurisdictionQuery, GetApplicationJurisdictionQueryVariables>(GetApplicationJurisdictionDocument, options);
      }
export function useGetApplicationJurisdictionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplicationJurisdictionQuery, GetApplicationJurisdictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplicationJurisdictionQuery, GetApplicationJurisdictionQueryVariables>(GetApplicationJurisdictionDocument, options);
        }
export type GetApplicationJurisdictionQueryHookResult = ReturnType<typeof useGetApplicationJurisdictionQuery>;
export type GetApplicationJurisdictionLazyQueryHookResult = ReturnType<typeof useGetApplicationJurisdictionLazyQuery>;
export type GetApplicationJurisdictionQueryResult = ApolloReactCommon.QueryResult<GetApplicationJurisdictionQuery, GetApplicationJurisdictionQueryVariables>;
export const GetCustomerAndBrokerInfoDocument = gql`
    query getCustomerAndBrokerInfo($invoiceIdOrGroupId: ObjectID!) {
  getCustomerAndBrokerInfo(invoiceIdOrGroupId: $invoiceIdOrGroupId) {
    groupId
    quoteId
    customerName
    customerEmail
    brokerName
    brokerEmail
  }
}
    `;

/**
 * __useGetCustomerAndBrokerInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomerAndBrokerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAndBrokerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAndBrokerInfoQuery({
 *   variables: {
 *      invoiceIdOrGroupId: // value for 'invoiceIdOrGroupId'
 *   },
 * });
 */
export function useGetCustomerAndBrokerInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomerAndBrokerInfoQuery, GetCustomerAndBrokerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomerAndBrokerInfoQuery, GetCustomerAndBrokerInfoQueryVariables>(GetCustomerAndBrokerInfoDocument, options);
      }
export function useGetCustomerAndBrokerInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerAndBrokerInfoQuery, GetCustomerAndBrokerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomerAndBrokerInfoQuery, GetCustomerAndBrokerInfoQueryVariables>(GetCustomerAndBrokerInfoDocument, options);
        }
export type GetCustomerAndBrokerInfoQueryHookResult = ReturnType<typeof useGetCustomerAndBrokerInfoQuery>;
export type GetCustomerAndBrokerInfoLazyQueryHookResult = ReturnType<typeof useGetCustomerAndBrokerInfoLazyQuery>;
export type GetCustomerAndBrokerInfoQueryResult = ApolloReactCommon.QueryResult<GetCustomerAndBrokerInfoQuery, GetCustomerAndBrokerInfoQueryVariables>;
export const GetDocumentInformationDocument = gql`
    query getDocumentInformation($policyId: String!) {
  getDocumentInformation(policyId: $policyId) {
    documentDownloadLink {
      COI
      PaymentReceipt
      T_CDocument
      policyDocument
    }
    policyDetails {
      namedInsured
      operations
      policyEndDate
      policyStartDate
      timeZone
      country
      insuredLocation {
        city
        postalCode
        province
        street
      }
      mailingAddress {
        city
        postalCode
        province
        street
      }
    }
  }
}
    `;

/**
 * __useGetDocumentInformationQuery__
 *
 * To run a query within a React component, call `useGetDocumentInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentInformationQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetDocumentInformationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocumentInformationQuery, GetDocumentInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentInformationQuery, GetDocumentInformationQueryVariables>(GetDocumentInformationDocument, options);
      }
export function useGetDocumentInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentInformationQuery, GetDocumentInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentInformationQuery, GetDocumentInformationQueryVariables>(GetDocumentInformationDocument, options);
        }
export type GetDocumentInformationQueryHookResult = ReturnType<typeof useGetDocumentInformationQuery>;
export type GetDocumentInformationLazyQueryHookResult = ReturnType<typeof useGetDocumentInformationLazyQuery>;
export type GetDocumentInformationQueryResult = ApolloReactCommon.QueryResult<GetDocumentInformationQuery, GetDocumentInformationQueryVariables>;
export const GetAuth0UserPoliciesDocument = gql`
    query getAuth0UserPolicies {
  getAuth0UserPolicies
}
    `;

/**
 * __useGetAuth0UserPoliciesQuery__
 *
 * To run a query within a React component, call `useGetAuth0UserPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0UserPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0UserPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuth0UserPoliciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuth0UserPoliciesQuery, GetAuth0UserPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuth0UserPoliciesQuery, GetAuth0UserPoliciesQueryVariables>(GetAuth0UserPoliciesDocument, options);
      }
export function useGetAuth0UserPoliciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuth0UserPoliciesQuery, GetAuth0UserPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuth0UserPoliciesQuery, GetAuth0UserPoliciesQueryVariables>(GetAuth0UserPoliciesDocument, options);
        }
export type GetAuth0UserPoliciesQueryHookResult = ReturnType<typeof useGetAuth0UserPoliciesQuery>;
export type GetAuth0UserPoliciesLazyQueryHookResult = ReturnType<typeof useGetAuth0UserPoliciesLazyQuery>;
export type GetAuth0UserPoliciesQueryResult = ApolloReactCommon.QueryResult<GetAuth0UserPoliciesQuery, GetAuth0UserPoliciesQueryVariables>;
export const GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdDocument = gql`
    query getDocuSignEnvelopeSignedStatusByInvoiceOrGroupId($invoiceOrGroupId: ObjectID!) {
  getDocuSignEnvelopeSignedStatusByInvoiceOrGroupId(
    invoiceOrGroupId: $invoiceOrGroupId
  )
}
    `;

/**
 * __useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery__
 *
 * To run a query within a React component, call `useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery({
 *   variables: {
 *      invoiceOrGroupId: // value for 'invoiceOrGroupId'
 *   },
 * });
 */
export function useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery, GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery, GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables>(GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdDocument, options);
      }
export function useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery, GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery, GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables>(GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdDocument, options);
        }
export type GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryHookResult = ReturnType<typeof useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery>;
export type GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdLazyQueryHookResult = ReturnType<typeof useGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdLazyQuery>;
export type GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryResult = ApolloReactCommon.QueryResult<GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQuery, GetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdQueryVariables>;
export const GetPaymentPlanOptionDocument = gql`
    query getPaymentPlanOption($InvoiceId: ObjectID!) {
  getUserPaymentPlanOption(InvoiceId: $InvoiceId) {
    paymentPlanId
    paymentPlan
    invoiceNumber
    invoiceDate
    quoteNumber
    totalPremiumAmount
    totalSurcharge
    totalTaxes
    totalPolicyFees
    totalServiceFees
    totalPayable
    policyInceptionDate
    downPayment
    numberOfInstallments
    installmentFrequency
    installmentAmount
    paymentSchedule
  }
}
    `;

/**
 * __useGetPaymentPlanOptionQuery__
 *
 * To run a query within a React component, call `useGetPaymentPlanOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPlanOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPlanOptionQuery({
 *   variables: {
 *      InvoiceId: // value for 'InvoiceId'
 *   },
 * });
 */
export function useGetPaymentPlanOptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentPlanOptionQuery, GetPaymentPlanOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentPlanOptionQuery, GetPaymentPlanOptionQueryVariables>(GetPaymentPlanOptionDocument, options);
      }
export function useGetPaymentPlanOptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentPlanOptionQuery, GetPaymentPlanOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentPlanOptionQuery, GetPaymentPlanOptionQueryVariables>(GetPaymentPlanOptionDocument, options);
        }
export type GetPaymentPlanOptionQueryHookResult = ReturnType<typeof useGetPaymentPlanOptionQuery>;
export type GetPaymentPlanOptionLazyQueryHookResult = ReturnType<typeof useGetPaymentPlanOptionLazyQuery>;
export type GetPaymentPlanOptionQueryResult = ApolloReactCommon.QueryResult<GetPaymentPlanOptionQuery, GetPaymentPlanOptionQueryVariables>;
export const OpenCustomerDocumentDocument = gql`
    query openCustomerDocument($policyId: String!, $documentType: String!) {
  openCustomerDocument(policyId: $policyId, documentType: $documentType)
}
    `;

/**
 * __useOpenCustomerDocumentQuery__
 *
 * To run a query within a React component, call `useOpenCustomerDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenCustomerDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenCustomerDocumentQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useOpenCustomerDocumentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OpenCustomerDocumentQuery, OpenCustomerDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenCustomerDocumentQuery, OpenCustomerDocumentQueryVariables>(OpenCustomerDocumentDocument, options);
      }
export function useOpenCustomerDocumentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenCustomerDocumentQuery, OpenCustomerDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenCustomerDocumentQuery, OpenCustomerDocumentQueryVariables>(OpenCustomerDocumentDocument, options);
        }
export type OpenCustomerDocumentQueryHookResult = ReturnType<typeof useOpenCustomerDocumentQuery>;
export type OpenCustomerDocumentLazyQueryHookResult = ReturnType<typeof useOpenCustomerDocumentLazyQuery>;
export type OpenCustomerDocumentQueryResult = ApolloReactCommon.QueryResult<OpenCustomerDocumentQuery, OpenCustomerDocumentQueryVariables>;
export const SendInvoiceLinkEmailDocument = gql`
    mutation sendInvoiceLinkEmail($encryptedString: String!, $invoiceId: String!) {
  sendInvoiceLinkEmail(encryptedString: $encryptedString, invoiceId: $invoiceId)
}
    `;
export type SendInvoiceLinkEmailMutationFn = ApolloReactCommon.MutationFunction<SendInvoiceLinkEmailMutation, SendInvoiceLinkEmailMutationVariables>;

/**
 * __useSendInvoiceLinkEmailMutation__
 *
 * To run a mutation, you first call `useSendInvoiceLinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceLinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceLinkEmailMutation, { data, loading, error }] = useSendInvoiceLinkEmailMutation({
 *   variables: {
 *      encryptedString: // value for 'encryptedString'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSendInvoiceLinkEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInvoiceLinkEmailMutation, SendInvoiceLinkEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInvoiceLinkEmailMutation, SendInvoiceLinkEmailMutationVariables>(SendInvoiceLinkEmailDocument, options);
      }
export type SendInvoiceLinkEmailMutationHookResult = ReturnType<typeof useSendInvoiceLinkEmailMutation>;
export type SendInvoiceLinkEmailMutationResult = ApolloReactCommon.MutationResult<SendInvoiceLinkEmailMutation>;
export type SendInvoiceLinkEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInvoiceLinkEmailMutation, SendInvoiceLinkEmailMutationVariables>;
export const SendTnCeSignatureDocument = gql`
    mutation sendTnCESignature($applicationGroupId: ObjectID!, $subject: String!, $message: String!) {
  sendTnCESignature(
    applicationGroupId: $applicationGroupId
    subject: $subject
    message: $message
  )
}
    `;
export type SendTnCeSignatureMutationFn = ApolloReactCommon.MutationFunction<SendTnCeSignatureMutation, SendTnCeSignatureMutationVariables>;

/**
 * __useSendTnCeSignatureMutation__
 *
 * To run a mutation, you first call `useSendTnCeSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTnCeSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTnCeSignatureMutation, { data, loading, error }] = useSendTnCeSignatureMutation({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendTnCeSignatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTnCeSignatureMutation, SendTnCeSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendTnCeSignatureMutation, SendTnCeSignatureMutationVariables>(SendTnCeSignatureDocument, options);
      }
export type SendTnCeSignatureMutationHookResult = ReturnType<typeof useSendTnCeSignatureMutation>;
export type SendTnCeSignatureMutationResult = ApolloReactCommon.MutationResult<SendTnCeSignatureMutation>;
export type SendTnCeSignatureMutationOptions = ApolloReactCommon.BaseMutationOptions<SendTnCeSignatureMutation, SendTnCeSignatureMutationVariables>;
export const StoreInvoiceInfoDocument = gql`
    mutation storeInvoiceInfo($invoice: InvoiceInfoInput!) {
  storeInvoiceInfo(invoice: $invoice)
}
    `;
export type StoreInvoiceInfoMutationFn = ApolloReactCommon.MutationFunction<StoreInvoiceInfoMutation, StoreInvoiceInfoMutationVariables>;

/**
 * __useStoreInvoiceInfoMutation__
 *
 * To run a mutation, you first call `useStoreInvoiceInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreInvoiceInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeInvoiceInfoMutation, { data, loading, error }] = useStoreInvoiceInfoMutation({
 *   variables: {
 *      invoice: // value for 'invoice'
 *   },
 * });
 */
export function useStoreInvoiceInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StoreInvoiceInfoMutation, StoreInvoiceInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StoreInvoiceInfoMutation, StoreInvoiceInfoMutationVariables>(StoreInvoiceInfoDocument, options);
      }
export type StoreInvoiceInfoMutationHookResult = ReturnType<typeof useStoreInvoiceInfoMutation>;
export type StoreInvoiceInfoMutationResult = ApolloReactCommon.MutationResult<StoreInvoiceInfoMutation>;
export type StoreInvoiceInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<StoreInvoiceInfoMutation, StoreInvoiceInfoMutationVariables>;
export const SendCoiDocument = gql`
    mutation sendCOI($additionalInsured: CoiAdditionalInsuredInput!, $policyFoxdenId: String!, $country: String!) {
  sendCOI(
    additionalInsured: $additionalInsured
    country: $country
    policyFoxdenId: $policyFoxdenId
  )
}
    `;
export type SendCoiMutationFn = ApolloReactCommon.MutationFunction<SendCoiMutation, SendCoiMutationVariables>;

/**
 * __useSendCoiMutation__
 *
 * To run a mutation, you first call `useSendCoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCoiMutation, { data, loading, error }] = useSendCoiMutation({
 *   variables: {
 *      additionalInsured: // value for 'additionalInsured'
 *      policyFoxdenId: // value for 'policyFoxdenId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSendCoiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCoiMutation, SendCoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendCoiMutation, SendCoiMutationVariables>(SendCoiDocument, options);
      }
export type SendCoiMutationHookResult = ReturnType<typeof useSendCoiMutation>;
export type SendCoiMutationResult = ApolloReactCommon.MutationResult<SendCoiMutation>;
export type SendCoiMutationOptions = ApolloReactCommon.BaseMutationOptions<SendCoiMutation, SendCoiMutationVariables>;
export const GetPaymentStatusDocument = gql`
    query getPaymentStatus($invoiceId: ObjectID!, $placeholder: JSONObject) {
  getPaymentStatus(invoiceId: $invoiceId, placeholder: $placeholder) {
    __typename
    ... on FoxdenError {
      fileName
      message
    }
    ... on PaymentStatus {
      isPaid
      isSettled
      policyFoxdenId
      isRenewalReserved
      effectiveDate
      transactionStartDate
      stripeCheckoutSessionRedirectUrl
      invoiceInfo {
        client {
          address {
            city
            postalCode
            street
            region
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatusQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      placeholder: // value for 'placeholder'
 *   },
 * });
 */
export function useGetPaymentStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
      }
export function useGetPaymentStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
        }
export type GetPaymentStatusQueryHookResult = ReturnType<typeof useGetPaymentStatusQuery>;
export type GetPaymentStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentStatusLazyQuery>;
export type GetPaymentStatusQueryResult = ApolloReactCommon.QueryResult<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>;
export const InitiatePaymentGetInvoiceDocument = gql`
    query initiatePaymentGetInvoice($invoiceId: ObjectID!) {
  getInvoice(invoiceId: $invoiceId) {
    __typename
    ... on GetInvoiceSuccess {
      isExpired
      invoiceInfo {
        invoiceDate
        invoiceNumber
        quoteNumber
        tax
        totalPremium
        policyFee
        currency
        client {
          address {
            city
            postalCode
            street
            region
          }
        }
      }
      isPaid
      policyFoxdenId
    }
    ... on FoxdenError {
      fileName
      message
    }
  }
}
    `;

/**
 * __useInitiatePaymentGetInvoiceQuery__
 *
 * To run a query within a React component, call `useInitiatePaymentGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaymentGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiatePaymentGetInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInitiatePaymentGetInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InitiatePaymentGetInvoiceQuery, InitiatePaymentGetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InitiatePaymentGetInvoiceQuery, InitiatePaymentGetInvoiceQueryVariables>(InitiatePaymentGetInvoiceDocument, options);
      }
export function useInitiatePaymentGetInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InitiatePaymentGetInvoiceQuery, InitiatePaymentGetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InitiatePaymentGetInvoiceQuery, InitiatePaymentGetInvoiceQueryVariables>(InitiatePaymentGetInvoiceDocument, options);
        }
export type InitiatePaymentGetInvoiceQueryHookResult = ReturnType<typeof useInitiatePaymentGetInvoiceQuery>;
export type InitiatePaymentGetInvoiceLazyQueryHookResult = ReturnType<typeof useInitiatePaymentGetInvoiceLazyQuery>;
export type InitiatePaymentGetInvoiceQueryResult = ApolloReactCommon.QueryResult<InitiatePaymentGetInvoiceQuery, InitiatePaymentGetInvoiceQueryVariables>;
export const GetPaymentRouteDeciderDocument = gql`
    query getPaymentRouteDecider($invoiceId: ObjectID!) {
  paymentRouteDecider(invoiceId: $invoiceId) {
    __typename
    GL {
      __typename
      ... on FoxdenError {
        fileName
        message
      }
      ... on IsPaid {
        policyNumber
      }
      ... on PartiallyPaid {
        redirectUrl
      }
      ... on IsExpired {
        isExpired
      }
      ... on InitialSuccess {
        getInvoiceDeciderResult {
          invoiceInfo {
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremium
            tax
            policyFee
            currency
            client {
              address {
                city
                postalCode
                street
                region
              }
            }
          }
          isPaid
          isExpired
          policyFoxdenId
          timeZone
          useCardForRenewals
        }
        userPaymentPlanOptionDeciderResult {
          userPaymentPlanOption {
            paymentPlanId
            paymentPlan
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremiumAmount
            totalSurcharge
            totalTaxes
            totalPolicyFees
            totalServiceFees
            totalPayable
            policyInceptionDate
            downPayment
            numberOfInstallments
            installmentFrequency
            installmentAmount
            paymentSchedule
            isDefault
          }
        }
      }
      ... on ChargeSuccess {
        getInvoiceDeciderResult {
          invoiceInfo {
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremium
            tax
            policyFee
            currency
          }
          isPaid
          isExpired
          policyFoxdenId
          timeZone
        }
        userPaymentPlanOptionDeciderResult {
          userPaymentPlanOption {
            paymentPlanId
            paymentPlan
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremiumAmount
            totalSurcharge
            totalTaxes
            totalPolicyFees
            totalServiceFees
            totalPayable
            policyInceptionDate
            downPayment
            numberOfInstallments
            installmentFrequency
            installmentAmount
            paymentSchedule
          }
        }
      }
      ... on RefundFullPaySuccess {
        refundedSequence {
          timestamp
          paymentIntentId
          invoiceId
          refundableAmount
        }
      }
    }
    EO {
      __typename
      ... on FoxdenError {
        fileName
        message
      }
      ... on IsPaid {
        policyNumber
      }
      ... on PartiallyPaid {
        redirectUrl
      }
      ... on IsExpired {
        isExpired
      }
      ... on InitialSuccess {
        getInvoiceDeciderResult {
          invoiceInfo {
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremium
            tax
            policyFee
            currency
            client {
              address {
                city
                postalCode
                street
                region
              }
            }
          }
          isPaid
          isExpired
          policyFoxdenId
          timeZone
          useCardForRenewals
        }
        userPaymentPlanOptionDeciderResult {
          userPaymentPlanOption {
            paymentPlanId
            paymentPlan
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremiumAmount
            totalSurcharge
            totalTaxes
            totalPolicyFees
            totalServiceFees
            totalPayable
            policyInceptionDate
            downPayment
            numberOfInstallments
            installmentFrequency
            installmentAmount
            paymentSchedule
            isDefault
          }
        }
      }
      ... on ChargeSuccess {
        getInvoiceDeciderResult {
          invoiceInfo {
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremium
            tax
            policyFee
            currency
          }
          isPaid
          isExpired
          policyFoxdenId
          timeZone
        }
        userPaymentPlanOptionDeciderResult {
          userPaymentPlanOption {
            paymentPlanId
            paymentPlan
            invoiceNumber
            invoiceDate
            quoteNumber
            totalPremiumAmount
            totalSurcharge
            totalTaxes
            totalPolicyFees
            totalServiceFees
            totalPayable
            policyInceptionDate
            downPayment
            numberOfInstallments
            installmentFrequency
            installmentAmount
            paymentSchedule
          }
        }
      }
      ... on RefundFullPaySuccess {
        refundedSequence {
          timestamp
          paymentIntentId
          invoiceId
          refundableAmount
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentRouteDeciderQuery__
 *
 * To run a query within a React component, call `useGetPaymentRouteDeciderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRouteDeciderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRouteDeciderQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetPaymentRouteDeciderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentRouteDeciderQuery, GetPaymentRouteDeciderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentRouteDeciderQuery, GetPaymentRouteDeciderQueryVariables>(GetPaymentRouteDeciderDocument, options);
      }
export function useGetPaymentRouteDeciderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentRouteDeciderQuery, GetPaymentRouteDeciderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentRouteDeciderQuery, GetPaymentRouteDeciderQueryVariables>(GetPaymentRouteDeciderDocument, options);
        }
export type GetPaymentRouteDeciderQueryHookResult = ReturnType<typeof useGetPaymentRouteDeciderQuery>;
export type GetPaymentRouteDeciderLazyQueryHookResult = ReturnType<typeof useGetPaymentRouteDeciderLazyQuery>;
export type GetPaymentRouteDeciderQueryResult = ApolloReactCommon.QueryResult<GetPaymentRouteDeciderQuery, GetPaymentRouteDeciderQueryVariables>;
export const GenerateSigningUrlDocument = gql`
    mutation generateSigningURL($quoteOrGroupId: ObjectID!) {
  generateSigningURL(quoteOrGroupId: $quoteOrGroupId)
}
    `;
export type GenerateSigningUrlMutationFn = ApolloReactCommon.MutationFunction<GenerateSigningUrlMutation, GenerateSigningUrlMutationVariables>;

/**
 * __useGenerateSigningUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSigningUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSigningUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSigningUrlMutation, { data, loading, error }] = useGenerateSigningUrlMutation({
 *   variables: {
 *      quoteOrGroupId: // value for 'quoteOrGroupId'
 *   },
 * });
 */
export function useGenerateSigningUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateSigningUrlMutation, GenerateSigningUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateSigningUrlMutation, GenerateSigningUrlMutationVariables>(GenerateSigningUrlDocument, options);
      }
export type GenerateSigningUrlMutationHookResult = ReturnType<typeof useGenerateSigningUrlMutation>;
export type GenerateSigningUrlMutationResult = ApolloReactCommon.MutationResult<GenerateSigningUrlMutation>;
export type GenerateSigningUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateSigningUrlMutation, GenerateSigningUrlMutationVariables>;